<template>
  <div class="event_details container">
    <h1>Event Details # {{ this.selectedEvent.invoice_number }}</h1>
    <div class="mb-2">
      <span v-if="this.selectedEvent.isOverdue" style="color: red">
        OVERDUE
      </span>
      <b-badge variant="warning" v-if="this.selectedEvent.is_suspended"
        v-b-tooltip.hover :title="this.selectedEvent.suspend_reason">
        Suspended
      </b-badge>
    </div>
    <b-button class="mb-2" variant="primary" @click="backTo"> Back </b-button>
    <b-button
      v-if="this.user.role == 'admin' || this.user.role == 'sales'"
      class="mb-2 ml-2"
      variant="primary"
      @click="showModal('edit-event')"
    >
      Edit
    </b-button>
    <b-button class="mb-2 ml-2" variant="primary" @click="exportEvent()">
      Export
    </b-button>
    <b-button
      v-if="
        (this.user.role == 'worker' || this.user.role == 'admin' || this.user.name == 'Christine') &&
          !this.selectedEvent.isAccepted &&
          !this.selectedEvent.isPending &&
          !this.selectedEvent.isDraft
      "
      class="mb-2 ml-2"
      variant="primary"
      @click="acceptEvent()"
    >
      Accept
    </b-button>
    <b-button
      v-if="this.selectedEvent.isPending"
      class="mb-2 ml-2"
      variant="primary"
      @click="allowEvent()"
    >
      Allow this event
    </b-button>

    <div>
      <b-button
        v-if="
          this.user.role != 'sales' && this.selectedEvent.isAccepted &&
            this.selectedEvent.type == 'installation' &&
            this.selectedEvent.sales_checklist.checkAshlars &&
            this.selectedEvent.isAshlarCompleted != null &&
            !this.selectedEvent.isAshlarCompleted &&
            !this.selectedEvent.is_suspended
        "
        class="mb-2 mr-2"
        variant="primary"
        @click="markAshlarAsCompleted"
      >
        Mark ashlar as completed
      </b-button>
      <b-button
        v-if="
          (this.user.role == 'worker' || this.user.role == 'admin' || this.user.name == 'Christine') &&
            !this.selectedEvent.isRequestingForCompletion &&
              !this.isRequestSent &&
            this.selectedEvent.status == 'active' &&
            this.selectedEvent.isAccepted
        "
        class="mb-2"
        variant="primary"
        @click="requestCompletion"
      >
        Request for completion
      </b-button>
      <b-button
        :disabled="true"
        v-if="
          ( this.user.name == 'Christine' ||
          this.user.role == 'worker') &&
          (this.selectedEvent.isRequestingForCompletion || this.isRequestSent) &&
          this.selectedEvent.isAccepted
        "
        class="mb-2"
        variant="primary"
      >
        Waiting for comfirmation</b-button
      >
      <b-button
        v-if="
          (this.user.role == 'sales' || this.user.role == 'admin' || this.user.name == 'Christine') &&
            this.selectedEvent.isRequestingForCompletion &&
            this.selectedEvent.isAccepted
        "
        class="mb-2"
        variant="primary"
        @click="markAsCompleted"
        >Mark as completed</b-button
      >
      <b-button
        v-if="
          (this.user.role == 'sales' || this.user.role == 'admin' || this.user.name == 'Christine') &&
            this.selectedEvent.isRequestingForCompletion &&
            this.selectedEvent.isAccepted
        "
        class="ml-2 mb-2"
        variant="danger"
        @click="showRejectModal"
        >Reject the completion request</b-button
      >
      <b-button
        v-if="
          (this.user.role == 'admin' || this.user.name == 'Christine')
          && !this.selectedEvent.is_suspended
          && !this.selectedEvent.isDraft
        "
        class="ml-2 mb-2"
        variant="warning"
        @click="showSuspendModal"
        >Suspend</b-button
      >
      <b-button
        v-if="
          (this.user.role == 'admin' || this.user.name == 'Christine')
          && this.selectedEvent.is_suspended
        "
        class="ml-2 mb-2"
        variant="warning"
        @click="showUnsuspendModal"
        >Unsuspend</b-button
      >

      <b-button
        v-if="this.selectedEvent.isDraft"
        class="mb-2"
        variant="primary"
        @click="showActiveDraftModal"
      >
        Active this draft
      </b-button>
    </div>

    <div class="tabs">
      <b-tabs content-class="mt-3">
        <b-tab title="Info" active>
          <b-row>
            <b-col cols="6">
              <p class="bold">Invoice Number</p>
              <p>{{ this.selectedEvent.invoice_number }}</p>
            </b-col>
            <b-col cols="6">
              <p class="bold">Client Name</p>
              <p>{{ this.selectedEvent.client_name }}</p>
            </b-col>
            <b-col cols="6">
              <p class="bold">Order Date</p>
              <p>{{ this.selectedEvent.order_date }}</p>
            </b-col>
            <b-col
              v-if="
                this.selectedEvent.type == 'installation' &&
                  this.selectedEvent.start_date.length > 0
              "
              cols="6"
            >
              <p class="bold">Ashlar Start Date</p>
              <p>{{ this.selectedEvent.start_date }}</p>
            </b-col>
            <b-col
              v-if="
                this.selectedEvent.type != 'installation' &&
                  this.selectedEvent.start_date.length > 0
              "
              cols="6"
            >
              <p class="bold">Start Date</p>
              <p>{{ this.selectedEvent.start_date }}</p>
            </b-col>
            <b-col v-if="this.selectedEvent.due_date.length > 0" cols="6">
              <p class="bold">Due Date</p>
              <p>{{ this.selectedEvent.due_date }}</p>
            </b-col>
            <b-col
              v-if="
                this.selectedEvent.ashlar_due.length > 0 &&
                  this.selectedEvent.sales_checklist.checkAshlars == 'true'
              "
              cols="6"
            >
              <p class="bold">Ashlar Due Date</p>
              <p>{{ this.selectedEvent.ashlar_due }}</p>
            </b-col>
            <b-col
              v-if="
                this.selectedEvent.headstone_start_date != null &&
                  this.selectedEvent.headstone_start_date.length > 0
              "
              cols="6"
            >
              <p class="bold">Headstone Start Date</p>
              <p>{{ this.selectedEvent.headstone_start_date }}</p>
            </b-col>
            <b-col cols="6">
              <p class="bold">Sales</p>
              <p>{{ this.selectedEvent.sales.name }}</p>
            </b-col>
            <b-col cols="6">
              <p class="bold">Installation Staff</p>
              <p>{{ this.selectedEvent.installation_staff_name }}</p>
            </b-col>
            <b-col cols="6">
              <p class="bold">Type</p>
              <p>{{ this.selectedEvent.type }}</p>
            </b-col>
            <b-col cols="6">
              <p for="cemetery" class="bold">Cemetery</p>
              <p>{{ this.selectedEvent.cemetery }}</p>
            </b-col>
            <b-col cols="6">
              <p for="store_location" class="bold">Store Location</p>
              <p>{{ this.selectedEvent.store_location }}</p>
            </b-col>
            <b-col cols="6">
              <p class="bold">Job Style</p>
              <p>{{ this.selectedEvent.job_style }}</p>
            </b-col>
            <b-col v-if="this.selectedEvent.type == 'inscription'" cols="6">
              <p class="pt-1 bold">Deposit Date</p>
              <p>{{ this.selectedEvent.inscription.deposit_date }}</p>
            </b-col>
            <b-col
              v-if="
                this.selectedEvent.type == 'inscription' &&
                  this.selectedEvent.inscription.request_date.length > 0
              "
              cols="6"
            >
              <p class="pt-1 bold">Request Date</p>
              <p>{{ this.selectedEvent.inscription.request_date }}</p>
            </b-col>
            <b-col
              v-if="
                this.selectedEvent.type == 'inscription' &&
                  this.selectedEvent.inscription.proof_back_date.length > 0
              "
              cols="6"
            >
              <p class="pt-1 bold">Proof Back Date</p>
              <p>{{ this.selectedEvent.inscription.proof_back_date }}</p>
            </b-col>
            <b-col
              v-if="
                this.selectedEvent.type == 'inscription' &&
                  this.selectedEvent.inscription.proof_signed_date.length > 0
              "
              cols="6"
            >
              <p class="pt-1 bold">Proof Signed Date</p>
              <p>{{ this.selectedEvent.inscription.proof_signed_date }}</p>
            </b-col>
            <b-col
              v-if="
                this.selectedEvent.type == 'inscription' &&
                  this.selectedEvent.inscription.proof_sent_date.length > 0
              "
              cols="6"
            >
              <p class="pt-1 bold">Proof Sent Date</p>
              <p>{{ this.selectedEvent.inscription.proof_sent_date }}</p>
            </b-col>
            <b-col
              v-if="
                this.selectedEvent.type !== 'inscription' &&
                  this.selectedEvent.complete_date.length > 0
              "
              cols="6"
            >
              <p class="pt-1 bold">Complete date</p>
              <p>{{ this.selectedEvent.complete_date }}</p>
            </b-col>
            <b-col cols="12">
              <p class="pt-1 bold">Task Detail</p>
              <p>{{ this.selectedEvent.taskDetail }}</p>
            </b-col>
          </b-row>
          <div v-if="this.selectedEvent.type == 'small task'">
            <strong> Subtasks </strong>
            <b-row v-for="(task, index) in subtasks" :key="index">
              <b-col cols="6">
                <p for="subtask_task_name">Task Name: {{ task.task_name }}</p>
              </b-col>
              <b-col cols="6">
                <p for="subtask_due_date">Due Date: {{ task.due_date }}</p>
              </b-col>
            </b-row>
          </div>
        </b-tab>

        <b-tab
          v-if="this.selectedEvent.type == 'installation'"
          title="Checklist"
        >
          <b-row>
            <b-col>
              <strong>Sales use</strong>
              <b-form-checkbox
                id="sales-checkbox-checkMonument"
                v-model="selectedEvent.sales_checklist.checkMonument"
                name="sales-checkbox-checkMonument"
                value="true"
                unchecked-value="false"
                :disabled="this.user.role == 'worker'"
              >
                <p class="compulsory-item">Monument(compulsory)</p>
              </b-form-checkbox>
              <b-form-checkbox
                id="sales-checkbox-checkPayment"
                v-model="selectedEvent.sales_checklist.checkPayment"
                name="sales-checkbox-checkPayment"
                value="true"
                unchecked-value="false"
                :disabled="this.user.role == 'worker'"
              >
                <p class="compulsory-item">100% Payment(compulsory)</p>
              </b-form-checkbox>
              <b-form-checkbox
                id="sales-checkbox-checkCemeteryPermit"
                v-model="selectedEvent.sales_checklist.checkCemeteryPermit"
                name="sales-checkbox-checkCemeteryPermit"
                value="true"
                unchecked-value="false"
                :disabled="this.user.role == 'worker'"
              >
                <p class="compulsory-item">Cemetery Permit(compulsory)</p>
              </b-form-checkbox>
              <b-form-checkbox
                id="sales-checkbox-checkFoundation"
                v-model="selectedEvent.sales_checklist.checkFoundation"
                name="sales-checkbox-checkFoundation"
                value="true"
                unchecked-value="false"
                :disabled="this.user.role == 'worker'"
              >
                <p class="compulsory-item">Foundation(compulsory)</p>
              </b-form-checkbox>
              <b-form-checkbox
                id="sales-checkbox-checkInscription"
                v-model="selectedEvent.sales_checklist.checkInscription"
                name="sales-checkbox-checkInscription"
                value="true"
                unchecked-value="false"
                :disabled="this.user.role == 'worker'"
              >
                <p class="compulsory-item">Inscription(compulsory)</p>
              </b-form-checkbox>
              <b-form-checkbox
                id="sales-checkbox-checkAccessory"
                v-model="selectedEvent.sales_checklist.checkAccessory"
                name="sales-checkbox-checkAccessory"
                value="true"
                unchecked-value="false"
                :disabled="this.user.role == 'worker'"
              >
                <p class="compulsory-item">
                  All accessories are ready(compulsory)
                </p>
              </b-form-checkbox>
              <b-form-checkbox
                id="sales-checkbox-checkAshlars"
                v-model="selectedEvent.sales_checklist.checkAshlars"
                name="sales-checkbox-checkAshlars"
                value="true"
                unchecked-value="false"
                :disabled="this.user.role == 'worker'"
              >
                Ashlars
                <p
                  v-if="this.selectedEvent.isAshlarCompleted"
                  style="display: inline-block"
                >
                  (completed)
                </p>
              </b-form-checkbox>
              <b-form-checkbox
                id="sales-checkbox-checkPhotosAFrames"
                v-model="selectedEvent.sales_checklist.checkPhotosAFrames"
                name="sales-checkbox-checkPhotosAFrames"
                value="true"
                unchecked-value="false"
                :disabled="this.user.role == 'worker'"
              >
                Photos & Frames
              </b-form-checkbox>

              <b-form-checkbox
                id="sales-checkbox-checkCandleBoxADoor"
                v-model="selectedEvent.sales_checklist.checkCandleBoxADoor"
                name="sales-checkbox-checkCandleBoxADoor"
                value="true"
                unchecked-value="false"
                :disabled="this.user.role == 'worker'"
              >
                Candle box & Door
              </b-form-checkbox>
              <b-form-checkbox
                id="sales-checkbox-checkHeadstone"
                v-model="selectedEvent.sales_checklist.checkHeadstone"
                name="sales-checkbox-checkHeadstone"
                value="true"
                unchecked-value="false"
                :disabled="this.user.role == 'worker'"
              >
                Headstone Door
              </b-form-checkbox>
              <b-form-checkbox
                id="sales-checkbox-checkKerb"
                v-model="selectedEvent.sales_checklist.checkKerb"
                name="sales-checkbox-checkKerb"
                value="true"
                unchecked-value="false"
                :disabled="this.user.role == 'worker'"
              >
                Kerb Door
              </b-form-checkbox>
              <b-form-checkbox
                id="sales-checkbox-checkCabinetDoor"
                v-model="selectedEvent.sales_checklist.checkCabinetDoor"
                name="sales-checkbox-checkCabinetDoor"
                value="true"
                unchecked-value="false"
                :disabled="this.user.role == 'worker'"
              >
                Cabinet Door
              </b-form-checkbox>
              <b-form-checkbox
                id="sales-checkbox-checkBookAWedge"
                v-model="selectedEvent.sales_checklist.checkBookAWedge"
                name="sales-checkbox-checkBookAWedge"
                value="true"
                unchecked-value="false"
                :disabled="this.user.role == 'worker'"
              >
                Book & Wedge
              </b-form-checkbox>
              <b-form-checkbox
                id="sales-checkbox-checkVaseAFlowerBox"
                v-model="selectedEvent.sales_checklist.checkVaseAFlowerBox"
                name="sales-checkbox-checkVaseAFlowerBox"
                value="true"
                unchecked-value="false"
                :disabled="this.user.role == 'worker'"
              >
                Vase & Flower box
              </b-form-checkbox>
              <b-form-checkbox
                id="sales-checkbox-checkReligiousStatue"
                v-model="selectedEvent.sales_checklist.checkReligiousStatue"
                name="sales-checkbox-checkReligiousStatue"
                value="true"
                unchecked-value="false"
                :disabled="this.user.role == 'worker'"
              >
                Religious Statue
              </b-form-checkbox>
              <b-form-checkbox
                id="sales-checkbox-checkLantern"
                v-model="selectedEvent.sales_checklist.checkLantern"
                name="sales-checkbox-checkLantern"
                value="true"
                unchecked-value="false"
                :disabled="this.user.role == 'worker'"
              >
                Lantern
              </b-form-checkbox>
              <b-form-checkbox
                id="sales-checkbox-checkCross"
                v-model="selectedEvent.sales_checklist.checkCross"
                name="sales-checkbox-checkCross"
                value="true"
                unchecked-value="false"
                :disabled="this.user.role == 'worker'"
              >
                Cross
              </b-form-checkbox>
              <b-form-checkbox
                id="sales-checkbox-checkLions"
                v-model="selectedEvent.sales_checklist.checkLions"
                name="sales-checkbox-checkLions"
                value="true"
                unchecked-value="false"
                :disabled="this.user.role == 'worker'"
              >
                Lions
              </b-form-checkbox>
              <b-form-checkbox
                id="sales-checkbox-checkSoilAPebble"
                v-model="selectedEvent.sales_checklist.checkSoilAPebble"
                name="sales-checkbox-checkSoilAPebble"
                value="true"
                unchecked-value="false"
                :disabled="this.user.role == 'worker'"
              >
                Soil and Pebble
              </b-form-checkbox>
              <b-form-checkbox
                id="sales-checkbox-checkMonumentPlan"
                v-model="selectedEvent.sales_checklist.checkMonumentPlan"
                name="sales-checkbox-checkMonumentPlan"
                value="true"
                unchecked-value="false"
                :disabled="this.user.role == 'worker'"
              >
                Monument Plan
              </b-form-checkbox>
              <b-form-checkbox
                id="sales-checkbox-checkCraneHire"
                v-model="selectedEvent.sales_checklist.checkCraneHire"
                name="sales-checkbox-checkCraneHire"
                value="true"
                unchecked-value="false"
                :disabled="this.user.role == 'worker'"
              >
                No Crane Hire
              </b-form-checkbox>

              <b-button
                v-if="
                  (this.user.role == 'sales' || this.user.role == 'admin' || this.user.name == 'Christine') &&
                    this.selectedEvent.status != 'completed'
                "
                block
                variant="primary"
                @click="updateChecklist"
                class="mt-4"
              >
                Update
              </b-button>
            </b-col>
            <b-col>
              <strong>Worker use</strong>
              <b-form-checkbox
                id="sales-checkbox-checkCementUse"
                v-model="
                  selectedEvent.installation_staff_checklist.checkCementUse
                "
                name="installation-checkbox-checkCementUse"
                value="true"
                unchecked-value="false"
                :disabled="
                  this.user.role !== 'worker' && this.user.role !== 'admin'
                "
              >
                Cement Use (Even Edge & No Leaking)
              </b-form-checkbox>
              <b-form-checkbox
                id="installation_staff-checkbox-checkDowels"
                v-model="selectedEvent.installation_staff_checklist.checkDowels"
                name="installation_staff-checkbox-checkDowels"
                value="true"
                unchecked-value="false"
                :disabled="
                  this.user.role !== 'worker' && this.user.role !== 'admin'
                "
              >
                Dowels (Must meet cemetery specifications)
              </b-form-checkbox>
              <b-form-checkbox
                id="installation_staff-checkbox-checkSilicone"
                v-model="
                  selectedEvent.installation_staff_checklist.checkSilicone
                "
                name="installation_staff-checkbox-checkSilicone"
                value="true"
                unchecked-value="false"
                :disabled="
                  this.user.role !== 'worker' && this.user.role !== 'admin'
                "
              >
                Silicone Apply
              </b-form-checkbox>
              <b-form-checkbox
                id="installation_staff-checkbox-checkClean"
                v-model="selectedEvent.installation_staff_checklist.checkClean"
                name="installation_staff-checkbox-checkClean"
                value="true"
                unchecked-value="false"
                :disabled="
                  this.user.role !== 'worker' && this.user.role !== 'admin'
                "
              >
                Clean
              </b-form-checkbox>
              <b-form-checkbox
                id="installation_staff-checkbox-checkOthers"
                v-model="selectedEvent.installation_staff_checklist.checkOthers"
                name="installation_staff-checkbox-checkOthers"
                value="true"
                unchecked-value="false"
                :disabled="
                  this.user.role !== 'worker' && this.user.role !== 'admin'
                "
              >
                Others
              </b-form-checkbox>
              <b-button
                v-if="
                  (this.user.role == 'worker' || this.user.role == 'admin' || this.user.name == 'Christine') &&
                    this.selectedEvent.status != 'completed'
                "
                block
                variant="primary"
                @click="updateChecklist"
                class="mt-4"
              >
                Update
              </b-button>
            </b-col>
          </b-row>
        </b-tab>

        <b-tab title="Files">
          <p v-if="this.isProcessing" style="color: red">
            Files are being uploaded. Please do not close the page.
          </p>
          <b-spinner v-if="isProcessing" label="Spinning"></b-spinner>
          <div v-if="this.files.length == 0">
            This event does not have any file yet.
          </div>
          <div v-if="this.files.length > 0" class="file-list">
            <div v-for="(file, index) in files" :key="index">
              <b-row class="mt-1 ml-1" align-h="between">
                <div>
                  {{ file.fileName }}
                  <b-icon
                    class="mt-1 pointer"
                    icon="arrow-down"
                    scale="1"
                    variant="success"
                    @click="downloadFile(index)"
                  ></b-icon>
                </div>
                <b-icon
                  class="mt-1 mr-4 pointer"
                  icon="trash-fill"
                  scale="1"
                  variant="danger"
                  @click="deleteFile(index)"
                ></b-icon>
              </b-row>
              <hr class="m-0 p-0" />
            </div>
          </div>
          <div class="fileUploadPanel">
            <b-form-file
              class="mt-3"
              v-model="selectedFile"
              :state="Boolean(selectedFile)"
              placeholder="Choose files or drop those here..."
              drop-placeholder="Drop file here..."
            ></b-form-file>
            <div class="mt-3">
              Selected files: {{ this.selectedFiles.length }}
            </div>
            <div>
              <b-row
                class="mt-1 ml-1"
                v-for="(file, index) in selectedFiles"
                :key="index"
              >
                {{ file.name }}
                <b-icon
                  class="mt-1 ml-1 pointer"
                  icon="x-circle"
                  scale="1"
                  variant="danger"
                  @click="removeFile(index)"
                ></b-icon>
              </b-row>
            </div>
            <!-- <b-progress class="mt-2" v-if="isUploading" :value="progress" :max="max" show-progress animated></b-progress> -->
            <b-button
              :disabled="
                this.selectedFiles.length == 0 || this.isProcessing
                  ? true
                  : false
              "
              class="mt-4"
              block
              variant="primary"
              @click="uploadFiles"
            >
              Upload</b-button
            >
            <!-- <b-button v-if="this.isProcessing" disabled="true">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
            </b-button> -->
          </div>
        </b-tab>

        <b-tab title="Comments">
          <template #title>
            Comments
          </template>
          <div v-if="this.comments.length == 0">
            This event does not have any comment yet.
          </div>
          <b-button variant="primary" v-b-modal.modal-create-comment>
            Add a comment
          </b-button>
          <b-card
            class="mt-2"
            :title="comment.creater"
            :sub-title="comment.time"
            v-for="(comment, index) in comments"
            :key="index"
          >
            <b-card-text>
              {{ comment.content }}
            </b-card-text>
          </b-card>
        </b-tab>

        <b-tab title="Complaint">
          <template #title>
            Complaint
          </template>
          <p
            v-if="
              this.selectedEvent.complaints == null ||
                this.selectedEvent.complaints.length == 0
            "
          >
            This event does not have any complaint yet.
          </p>
          <b-button variant="primary" v-b-modal.modal-create-complaint>
            Add a complaint</b-button
          >
          <!-- <b-button class="ml-2" variant="primary" >Export complaints</b-button> -->
          <b-card
            class="mt-2"
            :title="complaint.complaint_date"
            :sub-title="`Principal ${complaint.complaint_principal}`"
            v-for="(complaint, index) in this.complaints"
            :key="index"
          >
            <b-card-text>
              <strong>Content:</strong>
              <p>{{ complaint.complaint_content }}</p>

              <strong>How to fix this up?</strong>
              <p>{{ complaint.complaint_solution }}</p>

              <strong>What is the final action taken?</strong>
              <p>{{ complaint.complaint_furtherAction }}</p>
            </b-card-text>
          </b-card>
        </b-tab>

        <b-tab
          v-if="this.selectedEvent.installation_staff_name != 'Others'"
          title="Email"
        >
          <p style="margin: 0">
            This email will be sent to
            <strong v-if="this.user.role != 'admin' && this.user.name !== 'Christine'">{{
              email_recipient
            }}</strong>
          </p>
          <b-form @submit.prevent="onSend" @reset="onReset">
            <b-form-select
              v-if="this.user.role == 'admin' || this.user.name == 'Christine'"
              v-model="email_recipient"
              :options="[
                this.selectedEvent.installation_staff.email,
                this.selectedEvent.sales.email,
              ]"
              required
            ></b-form-select>
            <b-container fluid>
              <b-row class="my-1">
                <b-col cols="2">
                  <label class="pt-1" for="Subject">Subject:</label>
                </b-col>
                <b-col cols="6">
                  <b-form-input
                    :formatter="formatSubject"
                    :required="true"
                    type="text"
                    id="email_subject"
                    v-model="email_subject"
                    class="form-control"
                    placeholder="Subject"
                  ></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col cols="2">
                  <label class="pt-1" for="email_content">Content:</label>
                </b-col>
                <b-col cols="8">
                  <b-form-textarea
                    id="email_content"
                    v-model="email_content"
                    :formatter="formatContent"
                    :state="textarea_state"
                    :readonly="is_textarea_readonly"
                    :required="true"
                    placeholder="Enter something..."
                    rows="6"
                    max-rows="8"
                  ></b-form-textarea>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col cols="2"> </b-col>
                <b-col cols="2">
                  <b-button type="submit" variant="primary">Send</b-button>
                </b-col>
                <b-col cols="2">
                  <b-button type="reset" variant="danger">Reset</b-button>
                </b-col>
                <b-col cols="4">
                  <p class="px-1 text-right">{{ email_content.length }}/180</p>
                </b-col>
              </b-row>
            </b-container>
          </b-form>
        </b-tab>
        <b-tab title="Status Histories">
          <b-alert
            :variant="statusHistory.isDangerous ? 'warning' : 'success'"
            show
            class="mt-2"
            v-for="(statusHistory, index) in selectedEvent.status_histories"
            :key="index"
          >
            {{ statusHistory.user.name }} {{ statusHistory.name }} on
            {{ statusHistory.date }}
          </b-alert>
        </b-tab>
        <b-tab
          v-if="this.user.role == 'sales' || this.user.role == 'admin'"
          title="Edit Histories"
        >
          <div v-if="this.selectedEvent.editHistories.length == 0">
            This event does not have any edition yet.
          </div>
          <b-card
            class="mt-2"
            :title="editHistory.user.name"
            :sub-title="editHistory.date"
            v-for="(editHistory, index) in selectedEvent.editHistories"
            :key="index"
          >
            <b-button variant="primary" @click="showEditDetails(editHistory)"
              >Show Details</b-button
            >
          </b-card>
        </b-tab>
      </b-tabs>
    </div>

    <b-modal id="modal-suspend-event" hide-footer title="Suspend the event">
      <b-form @submit.prevent="suspendEvent">
        <p>You are suspending an event.</p>
        <label for="">Reason:</label>
        <b-form-textarea
          id="textarea"
          v-model="suspend_reason"
          rows="3"
          max-rows="6"
          required
        ></b-form-textarea>
        <div class="modal-footer">
          <b-button @click="hideModal('modal-suspend-event')">
            Cancel
          </b-button>
          <b-button type="submit" variant="warning">Suspend</b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-unsuspend-event" hide-footer title="Unsuspend the event">
      <b-form @submit.prevent="unsuspendEvent">
        <p>You are unsuspending an event.</p>
        <div class="modal-footer">
          <b-button @click="hideModal('modal-unsuspend-event')">
            Cancel
          </b-button>
          <b-button type="submit" variant="warning">Unsuspend</b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-create-comment" hide-footer title="Add a comment">
      <b-form @submit.prevent="createComment">
        <b-form-textarea
          id="textarea"
          v-model="newComment"
          placeholder="Enter something..."
          rows="3"
          max-rows="6"
          required
        ></b-form-textarea>
        <div class="modal-footer">
          <b-button @click="hideModal('modal-create-comment')">
            Cancel
          </b-button>
          <b-button type="submit" variant="primary">Create</b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-create-complaint" hide-footer title="Add a complaint">
      <b-form @submit.prevent="createComplaint">
        <b-row class="mx-2">
          <p class="mb-0" cols="12">Complaint Date:</p>
          <b-form-datepicker
            type="date"
            id="complaint_date"
            v-model="newComplaint.complaint_date"
            class="form-control"
            :required="true"
            cols="12"
          ></b-form-datepicker>
          <p class="mb-0" cols="12">Complaint Principal:</p>
          <b-form-input
            :required="true"
            type="text"
            id="complain_principal"
            v-model="newComplaint.complaint_principal"
            class="form-control"
            placeholder="Principal"
            cols="12"
          ></b-form-input>
          <p class="mb-0" cols="12">Complaint content:</p>
          <b-form-textarea
            id="complaint_content"
            v-model="newComplaint.complaint_content"
            placeholder="Complaint content..."
            rows="3"
            max-rows="6"
            required
          ></b-form-textarea>
          <p class="mb-0" cols="12">Complaint solution:</p>
          <b-form-textarea
            id="complaint_solution"
            v-model="newComplaint.complaint_solution"
            placeholder="Complaint solution..."
            rows="3"
            max-rows="6"
            required
          ></b-form-textarea>
          <p class="mb-0" cols="12">
            What is the fianl action taken?(by whom, on what date)
          </p>
          <b-form-textarea
            id="complaint_furtherAction"
            class="mb-3"
            v-model="newComplaint.complaint_furtherAction"
            placeholder="Further action..."
            rows="3"
            max-rows="6"
            required
          ></b-form-textarea>
        </b-row>
        <div class="modal-footer pb-0">
          <b-button @click="hideModal('modal-create-complaint')">
            Cancel
          </b-button>
          <b-button type="submit" variant="primary">Create</b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-email-confirmation" hide-footer title="Result">
      <p>You email has been sent successfully!</p>
      <div class="modal-footer">
        <b-button @click="hideModal('modal-email-confirmation')"> Ok </b-button>
      </div>
    </b-modal>

    <b-modal id="email_validation_message" hide-footer title="Result">
      {{ email_validation_message }}
      <div class="modal-footer">
        <b-button @click="hideModal('email_validation_message')"> Ok </b-button>
      </div>
    </b-modal>

    <b-modal id="edit-event" hide-footer title="Edit Event">
      <b-row>
        <b-col cols="6">
          <label for="form_details.installation_staff"
            >Installation Staff:</label
          >
          <b-form-select
            :disabled="isProcessing ? true : false"
            v-model="form_details.installation_staff"
            :options="workerNames"
          ></b-form-select>
        </b-col>
        <b-col cols="6">
          <label for="form_details.order_date">Order Date:</label>
          <b-form-datepicker
            :disabled="isProcessing ? true : false"
            type="date"
            id="order_date"
            v-model="form_details.order_date"
            class="form-control"
          ></b-form-datepicker>
        </b-col>
        <b-col cols="6">
          <label for="form_details.invoice_number">Invoice Number:</label>
          <input
            :disabled="isProcessing ? true : false"
            type="text"
            id="invoice_number"
            v-model="form_details.invoice_number"
            class="form-control"
          />
        </b-col>
        <b-col cols="6">
          <label for="form_details.client_name">Client Name:</label>
          <input
            :disabled="isProcessing ? true : false"
            type="text"
            id="client_name"
            v-model="form_details.client_name"
            class="form-control"
          />
        </b-col>
        <b-col cols="6">
          <label for="form_details.store_location">Store Location:</label>
          <b-form-select
            :disabled="isProcessing ? true : false"
            v-model="form_details.store_location"
            :options="store_names"
          ></b-form-select>
        </b-col>
        <b-col
          v-if="
            this.selectedEvent.type !== 'inscription' &&
              this.selectedEvent.isAccepted &&
              this.selectedEvent.type != 'installation'
          "
          cols="6"
        >
          <label for="form_details.start_date">Start Date:</label>
          <b-form-datepicker
            :disabled="isProcessing ? true : false"
            type="date"
            id="start_date"
            v-model="form_details.start_date"
            class="form-control"
          ></b-form-datepicker>
        </b-col>
        <b-col
          v-if="
            this.selectedEvent.type !== 'inscription' &&
              this.selectedEvent.isAccepted &&
              this.selectedEvent.sales_checklist.checkAshlars == 'true'
          "
          cols="6"
        >
          <label for="form_details.start_date">Ashlar Start Date:</label>
          <b-form-datepicker
            :disabled="isProcessing ? true : false"
            type="date"
            id="start_date"
            v-model="form_details.start_date"
            class="form-control"
          ></b-form-datepicker>
        </b-col>
        <b-col
          v-if="
            this.selectedEvent.type !== 'inscription' &&
              this.selectedEvent.isAccepted
          "
          cols="6"
        >
          <label for="form_details.headstone">Headstone Start Date:</label>
          <b-form-datepicker
            :disabled="isProcessing ? true : false"
            type="date"
            id="headstone_start_date"
            v-model="form_details.headstone_start_date"
            class="form-control"
          ></b-form-datepicker>
        </b-col>
        <b-col v-if="this.selectedEvent.type !== 'inscription'" cols="6">
          <label for="form_details.due_date">Due Date:</label>
          <b-form-datepicker
            :disabled="isProcessing ? true : false"
            type="date"
            id="due_date"
            v-model="form_details.due_date"
            class="form-control"
          ></b-form-datepicker>
        </b-col>
        <b-col
          v-if="
            this.selectedEvent.type == 'installation' &&
              this.selectedEvent.sales_checklist.checkAshlars == 'true'
          "
          cols="6"
        >
          <label for="form_details.ashlar_due">Ashlar Due:</label>
          <b-form-datepicker
            :disabled="
              isProcessing || this.selectedEvent.type !== 'installation'
                ? true
                : false
            "
            type="date"
            id="ashlar_due"
            v-model="form_details.ashlar_due"
            class="form-control"
          ></b-form-datepicker>
        </b-col>
        <b-col cols="6">
          <label for="form_details.cemetery">Cemetery:</label>
          <b-form-select
            :disabled="
              isProcessing
                ? true
                : false
            "
            v-model="form_details.cemetery"
            :options="cemeteryNames"
          ></b-form-select>
        </b-col>
        <b-col v-if="this.selectedEvent.type == 'installation'" cols="6">
          <label for="form_details.job_style">Job Style:</label>
          <b-form-select
            :disabled="
              isProcessing || this.selectedEvent.type !== 'installation'
                ? true
                : false
            "
            v-model="form_details.job_style"
            :options="job_style_names"
          ></b-form-select>
        </b-col>

        <b-col v-if="this.selectedEvent.type == 'inscription'" cols="6">
          <label for="edit_deposit_date">Deposit Date:</label>
          <b-form-datepicker
            :disabled="isProcessing ? true : false"
            type="date"
            id="edit_deposit_date"
            v-model="form_details.inscription.deposit_date"
            class="form-control"
          ></b-form-datepicker>
        </b-col>
        <b-col
          v-if="
            this.selectedEvent.type == 'inscription' &&
              this.form_details.inscription.deposit_date.length > 0
          "
          cols="6"
        >
          <label for="edit_request_date">Request Date:</label>
          <b-form-datepicker
            :disabled="isProcessing ? true : false"
            type="date"
            id="edit_request_date"
            v-model="form_details.inscription.request_date"
            class="form-control"
          ></b-form-datepicker>
        </b-col>
        <b-col
          v-if="
            this.selectedEvent.type == 'inscription' &&
              this.form_details.inscription.request_date.length > 0
          "
          cols="6"
        >
          <label for="edit_proof_back_date">Proof Back Date:</label>
          <b-form-datepicker
            :disabled="isProcessing ? true : false"
            type="date"
            id="edit_proof_back_date"
            v-model="form_details.inscription.proof_back_date"
            class="form-control"
          ></b-form-datepicker>
        </b-col>
        <b-col
          v-if="
            this.selectedEvent.type == 'inscription' &&
              this.form_details.inscription.proof_back_date.length > 0
          "
          cols="6"
        >
          <label for="edit_proof_signed_date">Proof Signed Date:</label>
          <b-form-datepicker
            :disabled="isProcessing ? true : false"
            type="date"
            id="edit_proof_signed_date"
            v-model="form_details.inscription.proof_signed_date"
            class="form-control"
          ></b-form-datepicker>
        </b-col>
        <b-col
          v-if="
            this.selectedEvent.type == 'inscription' &&
              this.form_details.inscription.proof_signed_date.length > 0
          "
          cols="6"
        >
          <label for="edit_proof_sent_date">Proof Sent Date:</label>
          <b-form-datepicker
            :disabled="isProcessing ? true : false"
            type="date"
            id="edit_proof_sent_date"
            v-model="form_details.inscription.proof_sent_date"
            class="form-control"
          ></b-form-datepicker>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="12">
          <label class="pt-1" for="form_details.task_detail"
            >Task Detail:</label
          >
          <b-form-textarea
            :disabled="isProcessing ? true : false"
            id="task_detail"
            v-model="form_details.task_detail"
            :required="true"
            placeholder="Enter something..."
            rows="6"
            max-rows="8"
          ></b-form-textarea>
        </b-col>
      </b-row>

      <div class="modal-footer">
        <b-button @click="hideModal('edit-event')"> Cancel </b-button>
        <b-button variant="primary" @click="editEvent('edit_validation_modal')">
          Update
        </b-button>
      </div>
    </b-modal>

    <b-modal id="edit_validation_modal" hide-footer title="Alert">
      {{ edit_validation_message }}
      <div class="modal-footer">
        <b-button @click="hideModal('email_validation_message')"
          >Cancel</b-button
        >
        <b-button variant="primary" @click="editEventTask">Update</b-button>
      </div>
    </b-modal>

    <b-modal id="edit_details_modal" hide-footer title="Edit Details">
      <b-row>
        <b-col cols="6">
          <strong>Original</strong>
        </b-col>
        <b-col cols="6">
          <strong>Edited</strong>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.invoice_number !==
              this.editHistoryDetails.new.invoice_number
          "
          cols="6"
        >
          <p>Invoice Number:</p>
          <p>{{ this.editHistoryDetails.old.invoice_number }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.invoice_number !==
              this.editHistoryDetails.new.invoice_number
          "
          cols="6"
        >
          <p>Invoice Number:</p>
          <p>{{ this.editHistoryDetails.new.invoice_number }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.order_date !==
              this.editHistoryDetails.new.order_date
          "
          cols="6"
        >
          <p>Order Date:</p>
          <p>{{ this.editHistoryDetails.old.order_date }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.order_date !==
              this.editHistoryDetails.new.order_date
          "
          cols="6"
        >
          <p>Order Date:</p>
          <p>{{ this.editHistoryDetails.new.order_date }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.start_date !==
              this.editHistoryDetails.new.start_date
          "
          cols="6"
        >
          <p>Start Date:</p>
          <p>{{ this.editHistoryDetails.old.start_date }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.start_date !==
              this.editHistoryDetails.new.start_date
          "
          cols="6"
        >
          <p>Start Date:</p>
          <p>{{ this.editHistoryDetails.new.start_date }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.client_name !==
              this.editHistoryDetails.new.client_name
          "
          cols="6"
        >
          <p>Client Name:</p>
          <p>{{ this.editHistoryDetails.old.client_name }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.client_name !==
              this.editHistoryDetails.new.client_name
          "
          cols="6"
        >
          <p>Client Name:</p>
          <p>{{ this.editHistoryDetails.new.client_name }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.store_location !==
              this.editHistoryDetails.new.store_location
          "
          cols="6"
        >
          <p>Store Location:</p>
          <p>{{ this.editHistoryDetails.old.store_location }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.store_location !==
              this.editHistoryDetails.new.store_location
          "
          cols="6"
        >
          <p>Store Location:</p>
          <p>{{ this.editHistoryDetails.new.store_location }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.job_style !==
              this.editHistoryDetails.new.job_style
          "
          cols="6"
        >
          <p>Job Style:</p>
          <p>{{ this.editHistoryDetails.old.job_style }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.job_style !==
              this.editHistoryDetails.new.job_style
          "
          cols="6"
        >
          <p>Job Style:</p>
          <p>{{ this.editHistoryDetails.new.job_style }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.due_date !==
              this.editHistoryDetails.new.due_date
          "
          cols="6"
        >
          <p>Due Date:</p>
          <p>{{ this.editHistoryDetails.old.due_date }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.due_date !==
              this.editHistoryDetails.new.due_date
          "
          cols="6"
        >
          <p>Due Date:</p>
          <p>{{ this.editHistoryDetails.new.due_date }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.cemetery !==
              this.editHistoryDetails.new.cemetery
          "
          cols="6"
        >
          <p>Cemetery:</p>
          <p>{{ this.editHistoryDetails.old.cemetery }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.cemetery !==
              this.editHistoryDetails.new.cemetery
          "
          cols="6"
        >
          <p>Cemetery:</p>
          <p>{{ this.editHistoryDetails.new.cemetery }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.task_detail !==
              this.editHistoryDetails.new.task_detail
          "
          cols="6"
        >
          <p>Task Detail:</p>
          <p>{{ this.editHistoryDetails.old.task_detail }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.task_detail !==
              this.editHistoryDetails.new.task_detail
          "
          cols="6"
        >
          <p>Task Detail:</p>
          <p>{{ this.editHistoryDetails.new.task_detail }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.ashlar_due !==
              this.editHistoryDetails.new.ashlar_due
          "
          cols="6"
        >
          <p>Ashlar Due:</p>
          <p>{{ this.editHistoryDetails.old.ashlar_due }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.ashlar_due !==
              this.editHistoryDetails.new.ashlar_due
          "
          cols="6"
        >
          <p>Ashlar Due:</p>
          <p>{{ this.editHistoryDetails.new.ashlar_due }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.inscription.deposit_date !==
              this.editHistoryDetails.new.inscription.deposit_date
          "
          cols="6"
        >
          <p>Deposit Date:</p>
          <p>{{ this.editHistoryDetails.old.inscription.deposit_date }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.inscription.deposit_date !==
              this.editHistoryDetails.new.inscription.deposit_date
          "
          cols="6"
        >
          <p>Deposit Date:</p>
          <p>{{ this.editHistoryDetails.new.inscription.deposit_date }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.inscription.request_date !==
              this.editHistoryDetails.new.inscription.request_date
          "
          cols="6"
        >
          <p>Request Date:</p>
          <p>{{ this.editHistoryDetails.old.inscription.request_date }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.inscription.request_date !==
              this.editHistoryDetails.new.inscription.request_date
          "
          cols="6"
        >
          <p>Request Date:</p>
          <p>{{ this.editHistoryDetails.new.inscription.request_date }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.inscription.proof_back_date !==
              this.editHistoryDetails.new.inscription.proof_back_date
          "
          cols="6"
        >
          <p>Proof Back Date:</p>
          <p>{{ this.editHistoryDetails.old.inscription.proof_back_date }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.inscription.proof_back_date !==
              this.editHistoryDetails.new.inscription.proof_back_date
          "
          cols="6"
        >
          <p>Proof Back Date:</p>
          <p>{{ this.editHistoryDetails.new.inscription.proof_back_date }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.inscription.proof_signed_date !==
              this.editHistoryDetails.new.inscription.proof_signed_date
          "
          cols="6"
        >
          <p>Proof Signed Date:</p>
          <p>{{ this.editHistoryDetails.old.inscription.proof_signed_date }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.inscription.proof_signed_date !==
              this.editHistoryDetails.new.inscription.proof_signed_date
          "
          cols="6"
        >
          <p>Proof Signed Date:</p>
          <p>{{ this.editHistoryDetails.new.inscription.proof_signed_date }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.inscription.proof_sent_date !==
              this.editHistoryDetails.new.inscription.proof_sent_date
          "
          cols="6"
        >
          <p>Proof Sent Date:</p>
          <p>{{ this.editHistoryDetails.old.inscription.proof_sent_date }}</p>
        </b-col>
        <b-col
          v-if="
            this.editHistoryDetails.old.inscription.proof_sent_date !==
              this.editHistoryDetails.new.inscription.proof_sent_date
          "
          cols="6"
        >
          <p>Proof Sent Date:</p>
          <p>{{ this.editHistoryDetails.new.inscription.proof_sent_date }}</p>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal id="accept_event" hide-footer title="Accept Event">
      <b-form @submit.prevent="acceptEventTask">
        <strong v-if="this.selectedEvent.type != 'installation'"
          >Start date:</strong
        >
        <strong
          v-if="
            this.selectedEvent.type == 'installation' &&
              this.selectedEvent.sales_checklist.checkAshlars == 'true'
          "
          >Ashlar start date:</strong
        >
        <b-form-datepicker
          v-if="this.selectedEvent.type != 'installation'"
          type="date"
          id="start_date"
          v-model="start_date"
          class="form-control"
          :min="minDate"
          required
        ></b-form-datepicker>
        <b-form-datepicker
          v-if="
            this.selectedEvent.type == 'installation' &&
              this.selectedEvent.sales_checklist.checkAshlars == 'true'
          "
          type="date"
          id="start_date"
          v-model="start_date"
          class="form-control"
          :min="minDate"
          required
        ></b-form-datepicker>
        <strong v-if="this.selectedEvent.type == 'installation'"
          >Headstone start date:</strong
        >
        <b-form-datepicker
          v-if="this.selectedEvent.type == 'installation'"
          type="date"
          id="headstone_start_date"
          v-model="headstone_start_date"
          class="form-control"
          :min="minDate"
          required
        ></b-form-datepicker>
        <!-- <strong>Headstone Start date:</strong>
        <b-form-datepicker type="date" id="headstone_start_date" v-model="headstone_start_date" class="form-control" :min="minDate"></b-form-datepicker> -->
        <div class="modal-footer">
          <b-button @click="hideModal('accept_event')"> Cancel </b-button>
          <b-button type="submit" variant="primary"> Comfirm </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="reject-modal" hide-footer title="Reject the request">
      <p>Please enter the reasons for rejecting:</p>
      <b-form @submit.prevent="rejectRequestTask">
        <b-form-textarea
          id="reject-detail"
          v-model="rejectDetail"
          placeholder="Enter something..."
          rows="6"
          max-rows="8"
          required
        ></b-form-textarea>
        <div class="modal-footer">
          <b-button @click="hideModal('reject-modal')"> Cancel </b-button>
          <b-button type="submit" variant="danger"> Send </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="file-deletion-confirmation"
      hide-footer
      title="You are deleting a file"
    >
      <p>This file will be permanently deleted.</p>
      <div class="modal-footer">
        <b-button @click="hideModal('file-deletion-confirmation')">
          Cancel
        </b-button>
        <b-button variant="danger" @click="deleteFileTask"> Delete </b-button>
      </div>
    </b-modal>
    
    <b-modal
      id="modal-active-draft"
      hide-footer
      title="Active the draft"
    >
      <p>This draft will be active and visible to worker.</p>
      <div class="modal-footer">
        <b-button @click="hideModal('modal-active-draft')">
          Cancel
        </b-button>
        <b-button variant="primary" @click="activeDraft"> Active </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  data() {
    return {
      suspend_reason: "",
      uploadedFileNames: [],
      rejectDetail: "",
      today: "",
      isRequestSent: false,
      selectedFile: null,
      selectedFiles: [],
      isProcessing: false,
      max: 100,
      progress: 0,
      completedFilesCount: 0,
      isComplete: false,
      isUploading: false,
      files: [],
      uploadedFiles: [],
      newComment: "",
      comments: [],
      email_subject: "",
      email_content: "",
      email_recipient: "",
      textarea_state: null,
      is_textarea_readonly: false,
      email_validation_message: "",
      minDate: new Date(),
      subtasks: [],
      start_date: "",
      headstone_start_date: "",
      sales_checklist: {
        checkAshlars: "false",
        checkMonument: "false",
        checkPhotosAFrames: "false",
        checkCandleBoxADoor: "false",
        checkHeadstone: "false",
        checkKerb: "false",
        checkCabinetDoor: "false",
        checkBookAWedge: "false",
        checkVaseAFlowerBox: "false",
        checkReligiousStatue: "false",
        checkLantern: "false",
        checkCross: "false",
        checkLions: "false",
        checkSoilAPebble: "false",
      },
      installation_staff_checklist: {
        checkCementUse: "false",
        checkDowels: "false",
        checkSilicone: "false",
        checkClean: "false",
        checkOthers: "false",
      },
      form_details: {
        order_date: "",
        start_date: "",
        headstone_start_date: "",
        invoice_number: "",
        client_name: "",
        store_location: "",
        job_style: "",
        due_date: "",
        sales: "",
        installation_staff: "",
        cemetery: "",
        task_detail: "",
        ashlar_due: "",
        inscription: {
          deposit_date: "",
          request_date: "",
          proof_back_date: "",
          proof_signed_date: "",
          proof_sent_date: "",
        },
      },
      editHistoryDetails: {
        old: {
          invoice_number: "",
          client_name: "",
          store_location: "",
          job_style: "",
          due_date: "",
          sales: "",
          installation_staff: "",
          cemetery: "",
          task_detail: "",
          ashlar_due: "",
          order_date: "",
          start_date: "",
          headstone_start_date: "",
          inscription: {
            deposit_date: "",
            request_date: "",
            proof_back_date: "",
            proof_signed_date: "",
            proof_sent_date: "",
          },
        },
        new: {
          invoice_number: "",
          client_name: "",
          store_location: "",
          job_style: "",
          due_date: "",
          sales: "",
          installation_staff: "",
          cemetery: "",
          task_detail: "",
          ashlar_due: "",
          order_date: "",
          start_date: "",
          headstone_start_date: "",
          inscription: {
            deposit_date: "",
            request_date: "",
            proof_back_date: "",
            proof_signed_date: "",
            proof_sent_date: "",
          },
        },
      },
      store_locations: ["Thomastown", "Springvale", "Dandenong"],
      job_styles: ["style1", "style2"],
      yesOrNo: ["yes", "no"],
      cemeteryNames: [],
      job_style_names: [],
      store_names: [],
      workers: [],
      workerNames: [],
      edit_validation_message: "This event will be permanently edited.",
      deletedFileIndex: 0,
      complaints: [],
      newComplaint: {
        complaint_date: "",
        complaint_principal: "",
        complaint_content: "",
        complaint_solution: "",
        complaint_furtherAction: "",
      },
    };
  },
  props: {
    from: String,
    user: Object,
    selectedEvent: Object,
  },
  created() {
    this.initiateToday();
    if (this.selectedEvent.complaints != null)
      this.complaints = this.selectedEvent.complaints;
    console.log(this.selectedEvent.id);

    if (this.selectedEvent.installation_staff != null) {
      if (this.user.role == "sales" || this.user.role == "admin")
        this.email_recipient = this.selectedEvent.installation_staff.email;
      if (this.user.role == "worker")
        this.email_recipient = this.selectedEvent.sales.email;
    }

    firebase
      .firestore()
      .collection("workers")
      .orderBy("name")
      .onSnapshot((collection) => {
        this.workers = collection.docs.map((doc) => doc.data());
        for (var i = 0; i < this.workers.length; i++) {
          this.workerNames.push(this.workers[i].name);
        }
        this.workerNames.push("Others");
      });

    firebase
      .firestore()
      .collection("events")
      .doc(this.selectedEvent.id)
      .onSnapshot((doc) => {
        this.files = doc.data().files;
        this.comments = doc.data().comments;
        this.subtasks = doc.data().subtasks;
      });

    firebase
      .firestore()
      .collection("cemeteries")
      .orderBy("name")
      .onSnapshot((collection) => {
        this.cemeteries = collection.docs.map((doc) => doc.data());
        for (var i = 0; i < this.cemeteries.length; i++) {
          this.cemeteryNames.push(this.cemeteries[i].name);
        }
      });

    firebase
      .firestore()
      .collection("store_locations")
      .orderBy("name")
      .onSnapshot((collection) => {
        this.store_locations = collection.docs.map((doc) => doc.data());
        for (var i = 0; i < this.store_locations.length; i++) {
          this.store_names.push(this.store_locations[i].name);
        }
      });

    firebase
      .firestore()
      .collection("job_styles")
      .orderBy("name")
      .onSnapshot((collection) => {
        this.job_styles = collection.docs.map((doc) => doc.data());
        for (var i = 0; i < this.job_styles.length; i++) {
          this.job_style_names.push(this.job_styles[i].name);
        }
      });

    console.log(this.selectedEvent.inscription);
    console.log(this.form_details.inscription);

    this.form_details = {
      invoice_number: this.selectedEvent.invoice_number,
      client_name: this.selectedEvent.client_name,
      store_location: this.selectedEvent.store_location,
      job_style: this.selectedEvent.job_style,
      order_date: this.selectedEvent.order_date,
      start_date: this.selectedEvent.start_date,
      headstone_start_date: this.selectedEvent.headstone_start_date,
      due_date: this.selectedEvent.due_date,
      installation_staff: this.selectedEvent.installation_staff_name,
      cemetery: this.selectedEvent.cemetery,
      task_detail: this.selectedEvent.taskDetail,
      inscription: {
        deposit_date: this.selectedEvent.inscription.deposit_date,
        request_date: this.selectedEvent.inscription.request_date,
        proof_back_date: this.selectedEvent.inscription.proof_back_date,
        proof_signed_date: this.selectedEvent.inscription.proof_signed_date,
        proof_sent_date: this.selectedEvent.inscription.proof_sent_date,
      },
      ashlar_due: this.selectedEvent.ashlar_due,
    };
    /* firebase.storage().ref('2144771.jpg').getDownloadURL().then(function(url) {
        // `url` is the download URL for 'images/stars.jpg'

        // This can be downloaded directly:
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.onload = function() {
          const blob = xhr.response;
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = '2144771';
          link.click();
          URL.revokeObjectURL(link.href);
        };
        xhr.open('GET', url);
        xhr.send();
        console.log("processed");
      }).catch(function(error) {
        // Handle any errors
        console.log(error);
      }); */

    /* firebase.storage().ref('2144771.jpg').getDownloadURL().then(function(url) {
        // `url` is the download URL for 'images/stars.jpg'

        // This can be downloaded directly:
        firebase.firestore().collection('mail').add({
          to: ["kane23333@gmail.com"],
          message: {
            subject: 'Congratulation!',
            text: 'You Have been hired.',
            html: 'this is <code>HTML</code> code .',
            attachments: [
              {   // use URL as an attachment
                filename: '2144771.jpeg',
                path: url
              },
            ]
          }
        });
      }).catch(function(error) {
        // Handle any errors
        console.log(error);
      }); */

    // if (this.selectedEvent.overdue_days) {
    //   var mdy = this.selectedEvent.due_date.split('-');
    //   var due = new Date(mdy[0], mdy[1]-1, (parseInt(mdy[2]) + 1).toString());
    //   //var gg = new Date();
    //   var start = new Date();
    //   //var start = new Date(gg.getDay(), gg.getMonth(), gg.getFullYear());
    //   this.overdueDays = -Math.round((due - start)/(1000*60*60*24));
    // }
  },
  watch: {
    selectedFile(newSelectedFile) {
      if (this.selectedFile != null) {
        this.selectedFiles.push(newSelectedFile);
      }
    },
    email_content(new_email_content) {
      if (new_email_content.length < 180) {
        this.textarea_state = null;
      } else {
        this.textarea_state = false;
      }
    },
  },
  methods: {
    activeDraft() {
      const database = firebase.firestore();
      this.selectedEvent.isDraft = false;
      const eventRef = database.collection("events").doc(this.selectedEvent.id);
      var activeEventRef = null;

      if (this.selectedEvent.status == "active") {
        activeEventRef = database.collection("activeEvents").doc(this.selectedEvent.id);
        activeEventRef.set({isDraft: false}, {merge: true});
      }
      eventRef.set({isDraft: false}, {merge: true});

      var mail1 = {
        to: [this.selectedEvent.installation_staff.email, 'rick@johnstonemart.com'],
        message: {
          subject: this.selectedEvent.invoice_number + '/' + this.selectedEvent.sales.name + '/' + this.selectedEvent.type + ' -  A new installation order has been activated',
          text: 'Dear ' + this.selectedEvent.installation_staff.name + ', \n' +
          'The installation order is received and will be processed accordingly. \n' +
          'Invoice number: ' + this.selectedEvent.invoice_number + '\n' +
          'Sales: ' + this.selectedEvent.sales.name + '\n' +
          'Type: ' + this.selectedEvent.type + '\n' +
          'Cemetery: ' + this.selectedEvent.cemetery + '\n' +
          'Due date: ' + this.selectedEvent.due_date
        }
      }

      firebase.firestore().collection('mail').add(mail1);

      this.hideModal('modal-active-draft');
    },
    showActiveDraftModal() {
      this.showModal('modal-active-draft');
    },
    showSuspendModal() {
      this.showModal('modal-suspend-event');
    },
    showUnsuspendModal() {
      this.showModal('modal-unsuspend-event');
    },
    suspendEvent() {
      const database = firebase.firestore();
      this.selectedEvent.is_suspended = true;
      this.selectedEvent.suspend_reason = this.suspend_reason;
      const eventRef = database.collection("events").doc(this.selectedEvent.id);
      var activeEventRef = null;

      if (this.selectedEvent.status == "active") {
        activeEventRef = database.collection("activeEvents").doc(this.selectedEvent.id);
        activeEventRef.set(this.selectedEvent, {merge: true});
      }
      eventRef.set(this.selectedEvent, {merge: true});

      var email = {
        from: this.user.email,
        to: [this.selectedEvent.sales.email, 'christina@johnstonemart.com'],
        message: {
          subject: this.selectedEvent.invoice_number + ' has been suspended',
          text: this.suspend_reason,
        },
      };

      firebase
        .firestore()
        .collection("mail")
        .add(email);

      this.hideModal('modal-suspend-event');
    },
    unsuspendEvent() {
      const database = firebase.firestore();
      this.selectedEvent.is_suspended = false;
      const eventRef = database.collection("events").doc(this.selectedEvent.id);
      var activeEventRef = null;

      if (this.selectedEvent.status == "active") {
        activeEventRef = database.collection("activeEvents").doc(this.selectedEvent.id);
        activeEventRef.set(this.selectedEvent, {merge: true});
      }
      eventRef.set(this.selectedEvent, {merge: true});

      var email = {
        from: this.user.email,
        to: [this.selectedEvent.sales.email, 'christina@johnstonemart.com'],
        message: {
          subject: this.selectedEvent.invoice_number + ' has been unsuspended',
          text: "",
        },
      };

      firebase
        .firestore()
        .collection("mail")
        .add(email);

      this.hideModal('modal-unsuspend-event');
    },
    createComplaint() {
      this.complaints.push(this.newComplaint);

      if (!this.selectedEvent.tags.includes("complaint")) {
        this.selectedEvent.tags.push("complaint");
        this.selectedEvent.tagStrings += " complaint";

        if (this.selectedEvent.status == "active") {
          firebase
            .firestore()
            .collection("activeEvents")
            .doc(this.selectedEvent.id)
            .set(
              {
                tags: this.selectedEvent.tags,
                tagStrings: this.selectedEvent.tagStrings,
              },
              { merge: true }
            );
        }

        firebase
          .firestore()
          .collection("events")
          .doc(this.selectedEvent.id)
          .set(
            {
              tags: this.selectedEvent.tags,
              tagStrings: this.selectedEvent.tagStrings,
            },
            { merge: true }
          );
      }

      if (this.selectedEvent.status == "active") {
        firebase
          .firestore()
          .collection("activeEvents")
          .doc(this.selectedEvent.id)
          .set(
            {
              complaints: this.complaints,
            },
            { merge: true }
          );
      }

      firebase
        .firestore()
        .collection("events")
        .doc(this.selectedEvent.id)
        .set(
          {
            complaints: this.complaints,
          },
          { merge: true }
        )
        .then(() => {
          alert("New complaint is created successfully!");
          this.hideModal("modal-create-complaint");
        });
    },
    deleteFile(index) {
      this.deletedFileIndex = index;
      this.showModal("file-deletion-confirmation");
    },
    deleteFileTask() {
      const index = this.deletedFileIndex;
      var deletedFile = this.files[index];
      this.selectedEvent.files.splice(index, 1);
      this.files.splice(index, 1);

      var database = firebase.firestore();
      var eventRef = database.collection("events").doc(this.selectedEvent.id);
      var activeEventsRef = null;

      if (this.selectedEvent.status == "active") {
        activeEventsRef = database
          .collection("activeEvents")
          .doc(this.selectedEvent.id);
        activeEventsRef.set(
          {
            files: this.files,
          },
          { merge: true }
        );
      }

      eventRef
        .set(
          {
            files: this.files,
          },
          { merge: true }
        )
        .then(() => {
          if (deletedFile.fileURL) {
            var storageRef = firebase.storage().ref();
            var desertRef = storageRef.child(
              "Events/" + this.selectedEvent.id + "/" + deletedFile.fileName
            );

            // Delete the file
            desertRef
              .delete()
              .then(function() {})
              .catch(function(error) {
                alert(error);
              });
          }

          this.hideModal("file-deletion-confirmation");
        })
        .catch((error) => {
          alert("Error updating document: ", error);
        });
    },
    initiateToday() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();

      this.today = yyyy + "-" + mm + "-" + dd;
    },
    acceptEvent() {
      this.showModal("accept_event");
    },
    acceptEventTask() {
      console.log(this.selectedEvent.sales_checklist.checkAshlars);
      if (
        (this.start_date == "" &&
          this.selectedEvent.sales_checklist.checkAshlars == "true") ||
        (this.selectedEvent.type == "installation" &&
          this.headstone_start_date == "")
      ) {
        alert("You have to enter the start date.");
        return;
      }

      var newStatusHistory = this.selectedEvent.status_histories;
      newStatusHistory.push({
        isDangerous: false,
        name: "accepted",
        date: this.today,
        user: this.user,
      });

      var database = firebase.firestore();
      var eventRef = database.collection("events").doc(this.selectedEvent.id);
      var activeEventsRef = null;
      this.selectedEvent.start_date = this.start_date;
      this.form_details.start_date = this.start_date;
      this.selectedEvent.headstone_start_date = this.headstone_start_date;
      this.form_details.headstone_start_date = this.headstone_start_date;

      if (this.selectedEvent.status == "active") {
        activeEventsRef = database
          .collection("activeEvents")
          .doc(this.selectedEvent.id);
        activeEventsRef.set(
          {
            start_date: this.start_date,
            start_year_month: this.start_date.substring(0, 7),
            start_day: parseInt(this.start_date.substring(8, 10)),
            headstone_start_date: this.headstone_start_date,
            headstone_start_year_month: this.headstone_start_date.substring(
              0,
              7
            ),
            headstone_start_day: parseInt(
              this.headstone_start_date.substring(8, 10)
            ),
            status_histories: newStatusHistory,
            isAccepted: true,
          },
          { merge: true }
        );
      }

      eventRef
        .set(
          {
            start_date: this.start_date,
            start_year_month: this.start_date.substring(0, 7),
            start_day: parseInt(this.start_date.substring(8, 10)),
            headstone_start_date: this.headstone_start_date,
            headstone_start_year_month: this.headstone_start_date.substring(
              0,
              7
            ),
            headstone_start_day: parseInt(
              this.headstone_start_date.substring(8, 10)
            ),
            status_histories: newStatusHistory,
            isAccepted: true,
          },
          { merge: true }
        )
        .then(() => {
          this.hideModal("accept_event");
          this.selectedEvent.isAccepted = true;
          alert("Accept successfully.");
        })
        .catch((error) => {
          alert("Error updating document: ", error);
        });
    },
    showEditDetails(edit) {
      this.showModal("edit_details_modal");
      this.editHistoryDetails = {
        old: edit.original_details,
        new: edit.edit_details,
      };
    },
    editEvent(id) {
      console.log("original: " + this.selectedEvent.inscription.deposit_date);
      console.log("new: " + this.form_details.inscription.deposit_date);
      if (this.form_details.inscription.proof_sent_date.length > 0) {
        this.edit_validation_message =
          "This process will generate a due date. Are you sure you want to continue?";
      }
      this.showModal(id);
    },
    editEventTask() {
      this.hideModal("edit_validation_modal");
      var database = firebase.firestore();
      var eventRef = database.collection("events").doc(this.selectedEvent.id);
      var activeEventsRef = null;

      var new_due_date_timestamp = null;

      console.log(this.form_details.inscription.proof_sent_date);

      if (
        this.selectedEvent.type == "inscription" &&
        this.form_details.inscription.proof_sent_date.length > 0
      ) {
        var proof_sent_date_array = this.form_details.inscription.proof_sent_date.split(
          "-"
        );
        var new_proof_sent_date_timestamp = new Date(
          proof_sent_date_array[0],
          proof_sent_date_array[1] - 1,
          proof_sent_date_array[2]
        );
        new_proof_sent_date_timestamp.setDate(
          new_proof_sent_date_timestamp.getDate() + 7
        );
        var dd = String(new_proof_sent_date_timestamp.getDate()).padStart(
          2,
          "0"
        );
        var mm = String(new_proof_sent_date_timestamp.getMonth() + 1).padStart(
          2,
          "0"
        ); //January is 0!
        var yyyy = new_proof_sent_date_timestamp.getFullYear();
        var new_due_date = yyyy + "-" + mm + "-" + dd;
        this.form_details.due_date = new_due_date;
        new_due_date_timestamp = new_proof_sent_date_timestamp;
      } else if (this.selectedEvent.type !== "inscription") {
        var due_date_array = this.form_details.due_date.split("-");
        new_due_date_timestamp = new Date(
          due_date_array[0],
          due_date_array[1] - 1,
          due_date_array[2]
        );
      }

      var new_ashlar_due = "";

      if (this.form_details.ashlar_due) {
        new_ashlar_due = this.form_details.ashlar_due;
      }

      var self = this;

      var today = new Date();
      dd = String(today.getDate()).padStart(2, "0");
      mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      yyyy = today.getFullYear();

      console.log(this.selectedEvent.inscription.deposit_date);

      var original_details = {
        invoice_number: this.selectedEvent.invoice_number,
        client_name: this.selectedEvent.client_name,
        store_location: this.selectedEvent.store_location,
        job_style: this.selectedEvent.job_style,
        order_date: this.selectedEvent.order_date,
        due_date: this.selectedEvent.due_date,
        installation_staff: this.selectedEvent.installation_staff,
        cemetery: this.selectedEvent.cemetery,
        task_detail: this.selectedEvent.taskDetail,
        inscription: this.selectedEvent.inscription,
        ashlar_due: this.selectedEvent.ashlar_due,
        start_date: this.selectedEvent.start_date,
        headstone: this.selectedEvent.headstone_start_date,
      };

      var editHistory = {
        date: yyyy + "-" + mm + "-" + dd,
        original_details: original_details,
        edit_details: this.form_details,
        user: this.user,
      };

      var new_editHistories = this.selectedEvent.editHistories;
      new_editHistories.push(editHistory);

      var newInstallationStaff = {};
      var newInstallationStaffName = "Others";

      console.log("1: " + this.form_details.installation_staff);

      if (this.form_details.installation_staff != "Others") {
        newInstallationStaff = this.workers[
          this.workerNames.indexOf(this.form_details.installation_staff)
        ];
        newInstallationStaffName = newInstallationStaff.name;
      }

      // set headstone start date for older orders

      // if (this.form_details.headstone_start_date == null) {
      //   this.form_details.headstone_start_date = "";
      // }

      // console.log("2: " + newInstallationStaff);

      console.log("invoice_number:" + this.form_details.invoice_number);
      console.log("client_name:" + this.form_details.client_name);
      console.log("store_location:" + this.form_details.store_location);
      console.log("job_style:" + this.form_details.job_style);
      console.log("due_date:" + this.form_details.due_date);
      console.log("order_date:" + this.form_details.order_date);
      console.log("start_date:" + this.form_details.start_date);
      console.log(
        "start_year_month:" + this.form_details.start_date.substring(0, 7)
      );
      console.log(
        "start_day:" + parseInt(this.form_details.start_date.substring(8, 10))
      );
      console.log(
        "headstone_start_date:" + this.form_details.headstone_start_date
      );
      console.log(
        "headstone_start_year_month:" +
          this.form_details.headstone_start_date.substring(0, 7)
      );
      console.log(
        "headstone_start_day:" +
          parseInt(this.form_details.headstone_start_date.substring(8, 10))
      );
      console.log("new_due_date_timestamp:" + new_due_date_timestamp);
      console.log("newInstallationStaff:" + newInstallationStaff);
      console.log("newInstallationStaffName:" + newInstallationStaffName);
      console.log("cemetery:" + this.form_details.cemetery);
      console.log("task_detail:" + this.form_details.task_detail);
      console.log("ashlar_due:" + this.form_details.ashlar_due);
      console.log("inscription:" + this.form_details.inscription);
      console.log(new_editHistories);

      if (this.selectedEvent.status == "active") {
        activeEventsRef = database
          .collection("activeEvents")
          .doc(this.selectedEvent.id);
        activeEventsRef.set(
          {
            invoice_number: this.form_details.invoice_number,
            client_name: this.form_details.client_name,
            store_location: this.form_details.store_location,
            job_style: this.form_details.job_style,
            due_date: this.form_details.due_date,
            order_date: this.form_details.order_date,
            start_date: this.form_details.start_date,
            start_year_month: this.form_details.start_date.substring(0, 7),
            start_day: parseInt(this.form_details.start_date.substring(8, 10)),
            headstone_start_date: this.form_details.headstone_start_date,
            headstone_start_year_month: this.form_details.headstone_start_date.substring(
              0,
              7
            ),
            headstone_start_day: parseInt(
              this.form_details.headstone_start_date.substring(8, 10)
            ),
            due_date_timestamp: new_due_date_timestamp,
            installation_staff: newInstallationStaff,
            installation_staff_name: newInstallationStaffName,
            cemetery: this.form_details.cemetery,
            taskDetail: this.form_details.task_detail,
            ashlar_due: this.form_details.ashlar_due,
            inscription: this.form_details.inscription,
            editHistories: new_editHistories,
            isOverdue: new Date(this.today) > new Date(this.form_details.due_date) ? true:false
          },
          { merge: true }
        );
      }

      eventRef
        .set(
          {
            invoice_number: this.form_details.invoice_number,
            client_name: this.form_details.client_name,
            store_location: this.form_details.store_location,
            job_style: this.form_details.job_style,
            due_date: this.form_details.due_date,
            order_date: this.form_details.order_date,
            start_date: this.form_details.start_date,
            start_year_month: this.form_details.start_date.substring(0, 7),
            start_day: parseInt(this.form_details.start_date.substring(8, 10)),
            headstone_start_date: this.form_details.headstone_start_date,
            headstone_start_year_month: this.form_details.headstone_start_date.substring(
              0,
              7
            ),
            headstone_start_day: parseInt(
              this.form_details.headstone_start_date.substring(8, 10)
            ),
            due_date_timestamp: new_due_date_timestamp,
            installation_staff: newInstallationStaff,
            installation_staff_name: newInstallationStaffName,
            cemetery: this.form_details.cemetery,
            taskDetail: this.form_details.task_detail,
            ashlar_due: this.form_details.ashlar_due,
            inscription: this.form_details.inscription,
            editHistories: new_editHistories,
            isOverdue: new Date(this.today) > new Date(this.form_details.due_date) ? true:false
          },
          { merge: true }
        )
        .then(() => {
          alert("Update successfully.");

          (self.selectedEvent.invoice_number =
            self.form_details.invoice_number),
            (self.selectedEvent.client_name = self.form_details.client_name),
            (self.selectedEvent.store_location =
              self.form_details.store_location),
            (self.selectedEvent.job_style = self.form_details.job_style),
            (self.selectedEvent.due_date = self.form_details.due_date),
            (self.selectedEvent.due_date_timestamp = new_due_date_timestamp),
            (self.selectedEvent.installation_staff = newInstallationStaff),
            (self.selectedEvent.installation_staff_name = newInstallationStaffName),
            (self.selectedEvent.cemetery = self.form_details.cemetery),
            (self.selectedEvent.taskDetail = self.form_details.task_detail),
            (self.selectedEvent.order_date = self.form_details.order_date),
            (self.selectedEvent.start_date = self.form_details.start_date),
            (self.selectedEvent.headstone_start_date =
              self.form_details.headstone_start_date),
            (self.selectedEvent.ashlar_due = new_ashlar_due),
            (self.selectedEvent.inscription = {
              deposit_date: this.form_details.inscription.deposit_date,
              request_date: this.form_details.inscription.request_date,
              proof_back_date: this.form_details.inscription.proof_back_date,
              proof_signed_date: this.form_details.inscription
                .proof_signed_date,
              proof_sent_date: this.form_details.inscription.proof_sent_date,
            });
          console.log("installation_staff_checklist successfully updated!");
        })
        .catch((error) => {
          console.error("Error updating document: ", error);
        });

      this.$bvModal.hide("edit-event");
    },
    updateChecklist() {
      console.log(this.selectedEvent.sales_checklist);
      var eventRef = firebase
        .firestore()
        .collection("events")
        .doc(this.selectedEvent.id);
      var activeEventsRef = null;

      if (this.selectedEvent.status == "active") {
        activeEventsRef = firebase
          .firestore()
          .collection("activeEvents")
          .doc(this.selectedEvent.id);
        activeEventsRef.set(
          {
            sales_checklist: this.selectedEvent.sales_checklist,
            installation_staff_checklist: this.selectedEvent
              .installation_staff_checklist,
          },
          { merge: true }
        );
      }

      eventRef
        .set(
          {
            sales_checklist: this.selectedEvent.sales_checklist,
            installation_staff_checklist: this.selectedEvent
              .installation_staff_checklist,
          },
          { merge: true }
        )
        .then(() => {
          alert("Update successfully.");
          console.log("sales_checklist successfully updated!");
        })
        .catch((error) => {
          console.error("Error updating document: ", error);
        });
    },
    allowEvent() {
      var eventRef = firebase
        .firestore()
        .collection("events")
        .doc(this.selectedEvent.id);
      var activeEventsRef = null;

      if (this.selectedEvent.status == "active") {
        activeEventsRef = firebase
          .firestore()
          .collection("activeEvents")
          .doc(this.selectedEvent.id);
        activeEventsRef
          .set({ isPending: false }, { merge: true })
          .then(() => {
            this.selectedEvent.isPending = false;
            console.log("Document isPending successfully updated!");
          })
          .catch((error) => {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
          });
      }

      eventRef
        .set({ isPending: false }, { merge: true })
        .then(() => {
          this.selectedEvent.isPending = false;
          console.log("Document isPending successfully updated!");
        })
        .catch((error) => {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
        });
    },
    exportEvent() {
      this.$emit("exportEvent", this.selectedEvent);
    },
    formatSubject(e) {
      return String(e).substring(0, 30);
    },
    formatContent(e) {
      return String(e).substring(0, 180);
    },
    onSend() {
      var self = this;

      this.email_validation_message = "";
      if (this.email_subject.length > 0 && this.email_content.length > 0) {
        console.log("validation is passed");
        var mail = {
          from: this.user.email,
          to: [this.email_recipient],
          message: {
            subject: this.email_subject,
            text:
              "This email is from IOS that is about " +
              this.selectedEvent.invoice_number +
              "\nHi " +
              this.email_recipient.split('@')[0] +
              ",\n" +
              this.email_content +
              "\n" +
              this.user.name
          },
        };
        return firebase
          .firestore()
          .collection("mail")
          .add(mail)
          .then(() => {
            console.log("Queued email for delivery!");
            self.email_subject = "";
            self.email_content = "";

            self.email_validation_message +=
              "The email has been sent successfully!";
            this.showModal("email_validation_message");
          });
      } else {
        this.email_validation_message += "missing subject/content";
        this.showModal("email_validation_message");
      }
    },
    onReset() {
      this.email_subject = "";
      this.email_content = "";
    },
    backTo() {
      this.$emit("backTo", this.from);
    },
    removeFile: function(index) {
      this.selectedFiles.splice(index, 1);
      this.selectedFile = null;
    },
    requestCompletion() {
      if (
        (this.selectedEvent.installation_staff_checklist.checkCementUse ==
          "true" &&
          this.selectedEvent.installation_staff_checklist.checkDowels ==
            "true" &&
          this.selectedEvent.installation_staff_checklist.checkSilicone ==
            "true" &&
          this.selectedEvent.installation_staff_checklist.checkClean ==
            "true" &&
          this.selectedEvent.installation_staff_checklist.checkOthers ==
            "true") ||
        this.selectedEvent.type == "small task"
      ) {
        this.updateChecklist();
        var eventRef = firebase
          .firestore()
          .collection("events")
          .doc(this.selectedEvent.id);
        var activeEventsRef = null;

        const self = this;

        var newStausHistories = this.selectedEvent.status_histories;
        newStausHistories.push({
          isDangerous: false,
          name: "requested for complete",
          date: this.today,
          user: this.user,
        });

        if (this.selectedEvent.status == "active") {
          activeEventsRef = firebase
            .firestore()
            .collection("activeEvents")
            .doc(this.selectedEvent.id);
          activeEventsRef.set(
            {
              isRequestingForCompletion: true,
              status_histories: newStausHistories,
            },
            { merge: true }
          );
        }

        eventRef
          .set(
            {
              isRequestingForCompletion: true,
              status_histories: newStausHistories,
            },
            { merge: true }
          )
          .then(() => {
            console.log("Request sent successfully!");
            var request_mail = {
              to: [self.selectedEvent.sales.email],
              message: {
                subject: "A task is waiting to be comfirmed",
                text:
                  "Hi " +
                  self.selectedEvent.sales.name +
                  ",\n" +
                  self.selectedEvent.installation_staff_name +
                  " has finished the job and is requesting you to confirm the task " +
                  self.selectedEvent.invoice_number +
                  ".",
              },
            };

            firebase
              .firestore()
              .collection("mail")
              .add(request_mail);
            self.isRequestingForCompletion = true;
            self.isRequestSent = true;
          })
          .catch((error) => {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
          });
      } else {
        alert("You need to make sure all the items of checklist are finished.");
      }
    },
    showRejectModal() {
      this.showModal("reject-modal");
    },
    rejectRequestTask() {
      var self = this;
      var eventRef = firebase
        .firestore()
        .collection("events")
        .doc(this.selectedEvent.id);
      var activeEventsRef = null;

      var newStausHistories = this.selectedEvent.status_histories;
      newStausHistories.push({
        isDangerous: true,
        name: "Rejected the request",
        date: this.today,
        user: this.user,
      });

      if (this.selectedEvent.status == "active") {
        activeEventsRef = firebase
          .firestore()
          .collection("activeEvents")
          .doc(this.selectedEvent.id);
        activeEventsRef.set(
          {
            isRequestingForCompletion: false,
            status_histories: newStausHistories,
          },
          { merge: true }
        );
      }

      eventRef
        .set(
          {
            isRequestingForCompletion: false,
            status_histories: newStausHistories,
          },
          { merge: true }
        )
        .then(() => {
          console.log("Reject the request successfully updated!");

          //console.log(self.selectedEvent.installation_staff.email);
          var reject_mail = {
            to: [self.selectedEvent.installation_staff.email],
            message: {
              subject: "A pending event is created",
              text:
                "Hi " +
                self.selectedEvent.installation_staff_name +
                ",\n" +
                "The Task " +
                self.selectedEvent.invoice_number +
                " does not meet the requirements. The deatils are as follows: \n" +
                self.rejectDetail,
            },
          };

          firebase
            .firestore()
            .collection("mail")
            .add(reject_mail);
          self.selectedEvent.isRequestingForCompletion = false;
          self.hideModal("reject-modal");
        })
        .catch((error) => {
          // The document probably doesn't exist.
          console.error("Error reject the request: ", error);
          self.selectedEvent.isRequestingForCompletion = false;
          self.hideModal("reject-modal");
        });
    },
    markAsCompleted() {
      var eventRef = firebase
        .firestore()
        .collection("events")
        .doc(this.selectedEvent.id);
      var activeEventsRef = null;
      var completedEventsRef = firebase
        .firestore()
        .collection("completeEvents")
        .doc(this.selectedEvent.id);

      this.selectedEvent.status = "completed";

      var newStausHistories = this.selectedEvent.status_histories;
      newStausHistories.push({
        isDangerous: false,
        name: "marked as complete",
        date: this.today,
        user: this.user,
      });

      this.selectedEvent.isRequestingForCompletion = false;
      this.selectedEvent.status_histories = newStausHistories;
      this.status = "completed";
      this.complete_date = this.today;

      activeEventsRef = firebase
        .firestore()
        .collection("activeEvents")
        .doc(this.selectedEvent.id);
      activeEventsRef.delete();

      completedEventsRef.set(this.selectedEvent);

      eventRef
        .set(
          {
            isRequestingForCompletion: false,
            status_histories: newStausHistories,
            status: "completed",
            complete_date: this.today,
          },
          { merge: true }
        )
        .then(() => {
          if (this.selectedEvent.type == 'installation') {
            firebase.firestore().collection("follow_up_reports").where('invoice_number', '==', this.selectedEvent.invoice_number).get().then((collection) => {
              var reports = collection.docs.map((doc) => doc.data());
              reports.forEach((data) => {
                data.job_complete_date = this.today;
                const report_ref = firebase.firestore().collection("follow_up_reports").doc(data.id);
                report_ref.set(data, {merge: true});
              });
            });
          }
          console.log("Document successfully updated!");
        })
        .catch((error) => {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
        });

      this.$emit("backTo", "Events");
    },
    hideModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    createComment() {
      var formatted_date = new Date().toJSON().slice(0, 10);
      this.selectedEvent.comments.push({
        content: this.newComment,
        creater: this.user.name,
        time: formatted_date,
      });
      var self = this;

      var eventsRef = firebase
        .firestore()
        .collection("events")
        .doc(self.selectedEvent.id);
      var activeEventsRef = null;

      if (this.selectedEvent.status == "active") {
        activeEventsRef = firebase
          .firestore()
          .collection("activeEvents")
          .doc(this.selectedEvent.id);
        activeEventsRef.set(
          { comments: self.selectedEvent.comments },
          { merge: true }
        );
      }

      eventsRef
        .set({ comments: self.selectedEvent.comments }, { merge: true })
        .then(() => {
          console.log("Document successfully updated!");
          self.$bvModal.hide("modal-create-comment");
        })
        .catch((error) => {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
        });

      const recipient_email =
        this.user.role == "sales"
          ? this.selectedEvent.installation_staff.email
          : this.selectedEvent.sales.email;
      const recipient_name =
        this.user.role == "sales"
          ? this.selectedEvent.installation_staff.name
          : this.selectedEvent.sales.name;
      var commentEmail = {
        from: this.user.email,
        to: [recipient_email],
        message: {
          subject: this.user.name + " has left a comment<No reply>",
          text:
            "Hi " +
            recipient_name +
            ", \n" +
            this.newComment +
            "\nInvoice number: " +
            this.selectedEvent.invoice_number +
            "\nDue date: " +
            this.selectedEvent.due_date
        },
      };

      firebase
        .firestore()
        .collection("mail")
        .add(commentEmail);
    },
    downloadFile(index) {
      window.open(this.files[index].fileURL);
    },
    uploadFiles() {
      for (var i = 0; i < this.selectedFiles.length; i++) {
        for (var c = 0; c < this.files.length; c++) {
          if (this.selectedFiles[i].name == this.files[c].fileName) {
            console.log(this.selectedFiles[i].name + this.files[c].fileName);
            alert("Do not upload duplicate file!");
            return;
          }
        }
      }
      console.log("uploading starts");
      this.selectedFile = null;
      this.progress = 0;
      this.isUploading = true;
      this.isProcessing = true;

      if (this.selectedFiles.length > 0) {
        var storageRef = firebase.storage().ref();
        //var self = this;
        // var uploadTasks = [];
        // var index = 0;
        // var subIndex = 0;
        // var urlIndex = 0;
        // var uploadedIndex = 0;
        // var uploadedFiles = this.files;
        // var uploadingTasks = [];

        for (
          var fileIndex = 0;
          fileIndex < this.selectedFiles.length;
          fileIndex++
        ) {
          var fileName = this.selectedFiles[fileIndex].name;
          this.uploadedFileNames.push(fileName);
        }

        const directoryPrefix = "Events/" + this.selectedEvent.id + "/";

        for (
          var uploadedFilseIndex = 0;
          uploadedFilseIndex < this.selectedEvent.files.length;
          uploadedFilseIndex++
        ) {
          this.uploadedFiles.push(this.selectedEvent.files[uploadedFilseIndex]);
        }

        this.uploadFileTask(storageRef, directoryPrefix, 0);
      }
    },
    markAshlarAsCompleted() {
      var eventRef = firebase
        .firestore()
        .collection("events")
        .doc(this.selectedEvent.id);
      var activeEventsRef = null;

      if (this.selectedEvent.status == "active") {
        activeEventsRef = firebase
          .firestore()
          .collection("activeEvents")
          .doc(this.selectedEvent.id);
        activeEventsRef.set(
          {
            isAshlarCompleted: true,
          },
          { merge: true }
        );
      }

      eventRef.set(
        {
          isAshlarCompleted: true,
        },
        { merge: true }
      );

      this.selectedEvent.isAshlarCompleted = true;
      alert('Operation done successfully.');

      if (this.selectedEvent.type == 'installation') {
        firebase.firestore().collection("follow_up_reports").where('invoice_number', '==', this.selectedEvent.invoice_number).get().then((collection) => {
          var reports = collection.docs.map((doc) => doc.data());
          reports.forEach((data) => {
            data.installation_booked_date = this.today;
            const report_ref = firebase.firestore().collection("follow_up_reports").doc(data.id);
            report_ref.set(data, {merge: true});
          });
        });
      }

      return;
    },
    uploadFileTask(storageRef, directoryPrefix, uploadedFilesCount) {
      if (uploadedFilesCount == this.selectedFiles.length) {
        this.uploadedFiles.concat(this.selectedEvent.files);
        var eventsRef = firebase
          .firestore()
          .collection("events")
          .doc(this.selectedEvent.id);
        var activeEventsRef = null;

        if (this.selectedEvent.status == "active") {
          activeEventsRef = firebase
            .firestore()
            .collection("activeEvents")
            .doc(this.selectedEvent.id);
          activeEventsRef.set(
            {
              files: this.uploadedFiles,
            },
            { merge: true }
          );
        }

        eventsRef.set(
          {
            files: this.uploadedFiles,
          },
          { merge: true }
        );
        this.selectedEvent.files = this.uploadedFiles;
        this.uploadedFiles = [];
        this.selectedFiles = [];
        this.uploadedFileNames = [];
        this.isComplete = true;
        this.isProcessing = false;
        this.isUploading = false;
        return;
      }

      const self = this;
      const uploadingFile = this.selectedFiles[uploadedFilesCount];
      const uploadingTask = storageRef
        .child(directoryPrefix + uploadingFile.name)
        .put(uploadingFile, uploadingFile.type);
      //uploadingTasks.push(uploadingTask);
      uploadingTask.then((data) => {
        data.ref.getDownloadURL().then((url) => {
          self.uploadedFiles.push({
            fileName: this.uploadedFileNames[uploadedFilesCount],
            fileURL: url,
          });
          ++uploadedFilesCount;
          self.uploadFileTask(
            storageRef,
            directoryPrefix,
            uploadedFilesCount,
            false
          );
        });
      });
    },
  },
};
</script>

<style>
.pointer {
  cursor: pointer;
}

.bold {
  font-weight: bold;
}

.event_details .comment-indicator {
  widows: 10px;
  height: 10px;
  background-color: red;
  border-radius: 5px;
  display: inline-block;
}

.file-list {
  border: 1px solid gainsboro;
  border-radius: 5px;
}

p {
  white-space: pre-wrap;
}

p.compulsory-item {
  display: inline;
}

p.unchecked {
  color: red;
}
</style>
